import React from "react"
import ProductScrollableList from "../ui/ProductScrollableList"
import AppsIcons from "../ui/AppsIcons"
import useT from "../hooks/useT"
import { usePageTitle } from "../hooks/usePageTitle"

/**
 * /creators and /authors. The old SPA rendered a mock creator profile here
 * (no creator directory API exists); this landing lists the latest titles
 * and points to the author pages linked from every product.
 * TODO: creator directory once the API exposes one.
 */
export default function CreatorsPage() {
  const t = useT()
  usePageTitle(t`Creators`)

  return (
    <div className="flex w-full flex-col items-center">
      <div className="relative flex w-full flex-col items-center justify-center bg-accent_bg px-4 pt-10 md:pt-[70px] pb-10 gap-4 text-center min-h-[300px] md:min-h-[380px]">
        <div className="flex h-[150px] w-[150px] md:h-[190px] md:w-[190px] items-center justify-center rounded-full border-4 border-white bg-[#6c7280]">
          <img src="/static/p-images/aldoo-small--150x150.webp" alt="" width={90} height={90} />
        </div>
        <h1 className="m-0 text-[26px] sm:text-[32px] md:text-[50px] font-bold">{t`Creators`}</h1>
        <p className="m-0 max-w-[600px] text-[16px] md:text-[20px] text-text_secondary">
          {t`Authors, narrators, illustrators and musicians publishing on Aldoo. Open any title to visit its creator's page.`}
        </p>
      </div>

      <div className="w-full max-w-[1410px] flex flex-col items-center py-10 sm:py-[72px] px-[10px] sm:px-[30px]">
        <ProductScrollableList placement="creators" category="latest" title={t`Latest`} sortBy="published" className="mb-[60px]" />
        <ProductScrollableList placement="creators" category="popular" title={t`Popular`} className="mb-[60px]" />
      </div>

      <div className="flex w-full flex-col items-center gap-5 bg-neutral py-12 px-4">
        <h2 className="m-0 text-[16px] md:text-[20px] lg:text-[24px] font-bold text-center">{t`Download our mobile app`}</h2>
        <AppsIcons />
      </div>
    </div>
  )
}
